package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.inject
import system.*
import ui.hud.*

class PauseSystem(
    private val gameHUD: GameHUD = inject(),
    private val sessionData: SessionData = inject()
) : IntervalSystem() {

    private var pausing = false

    override fun onTick() {
        if (sessionData.isPaused && !pausing) {
            pausing = true
            world.system<DashControlSystem>().enabled = false
            world.system<PlayerControlSystem>().enabled = false
            gameHUD.disable()
        }
        if (!sessionData.isPaused && pausing) {
            pausing = false
            world.system<DashControlSystem>().enabled = true
            world.system<PlayerControlSystem>().enabled = true
            gameHUD.enable()
        }
    }
}

data class SessionData(
    var isPaused: Boolean
)
